import { ColoursObj, Icon } from '@eventr/common-storybook'
import { Fab } from '@mui/material'
import { useCallback } from 'react'
import { useShallow } from 'zustand/react/shallow'
import { useEphemeralStore } from '../../../../state/useEphemeralStore'

export default function RecentreMapControl() {
    const includeLiveLocationsInBounds = useEphemeralStore(
        useShallow((s) => s.includeLiveLocationsInBounds)
    )

    const recenter = useCallback(() => {
        ///recenter will just toggle to center on location and itinerary
        useEphemeralStore.setState({
            includeLiveLocationsInBounds: !includeLiveLocationsInBounds,
        })
    }, [includeLiveLocationsInBounds])

    return (
        <Fab
            style={{
                backgroundColor: ColoursObj.shades.shade4,
            }}
            size="medium"
            onClick={recenter}
        >
            <div
                style={{
                    transform: 'translate(0px, 1px)',
                }}
            >
                <Icon name={'Location'} width="28px" height="28px" />
            </div>
        </Fab>
    )
}
